import SkeletonVideoFeed from "../../components/Common/SkeletonVideoFeed";
import SingleVideo from "./SingleVideo";

const Video = ({rounds, loading, loadingMore, paidLoveReact, currentUser}) => {
  return (
    <>
      {loading ? (
        <SkeletonVideoFeed />
      ) : (
        <>
          {rounds?.map((uploadVideo, index) => (
            <SingleVideo 
              key={uploadVideo.id || index} 
              paidLoveReact={paidLoveReact} 
              uploadVideo={uploadVideo} 
              currentUser={currentUser} 
            />
          ))}
          {loadingMore && <SkeletonVideoFeed />}
        </>
      )}
    </>
  );
};

export default Video;